import type { AcquisitionTag, IRentalTag, IServerTag, SaleTag } from './types'
import { tagsTypesEnum } from './types'

export const adaptServerSaleTag = (tag: IServerTag): SaleTag | undefined =>
    tag
        ? {
              ...tag,
              __typename: tagsTypesEnum.enum.saleTag,
          }
        : undefined

export const adaptServerAcquisitionTag = (tag: IServerTag): AcquisitionTag | undefined =>
    tag
        ? {
              ...tag,
              __typename: tagsTypesEnum.enum.acquisitionTag,
          }
        : undefined

export const adaptServerRentalTag = (tag: IServerTag): IRentalTag | undefined =>
    tag
        ? {
              ...tag,
              __typename: tagsTypesEnum.enum.rentalTag,
          }
        : undefined
